// @flow
import psq1 from './psq1.json'
import psq2 from './psq2.json'
import psq3 from './psq3.json'
import psq4 from './psq4.json'
import psq5 from './psq5.json'
import psq6 from './psq6.json'
import psq7 from './psq7.json'
import psq8 from './psq8.json'
import psq9 from './psq9.json'
import psq10 from './psq10.json'
import psq11 from './psq11.json'
import psq12 from './psq12.json'
import psq13 from './psq13.json'
import psq14 from './psq14.json'
import psq15 from './psq15.json'
import psq16 from './psq16.json'
import psq17 from './psq17.json'
import psq18 from './psq18.json'
import psq19 from './psq19.json'
import psq20 from './psq20.json'
import psq21 from './psq21.json'

const prescreeningQuiz = {
    psq1,
    psq2,
    psq3,
    psq4,
    psq5,
    psq6,
    psq7,
    psq8,
    psq9,
    psq10,
    psq11,
    psq12,
    psq13,
    psq14,
    psq15,
    psq16,
    psq17,
    psq18,
    psq19,
    psq20,
    psq21
}

export default prescreeningQuiz;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/prescreening/index.js